import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterDropdownButton } from '../filters-dropdown/FilterDropdownButton';
import { CustomDropdown } from '../../../../components/custom-dropdown/CustomDropdown';
import { FilterDropdownBox } from '../filters-dropdown/FilterDropdownBox';
import { FilterDropdown } from '../filters-dropdown/FilterDropdown';
import { SortList } from '../../search-sort/sort-list/SortList';
import { searchConstants } from '../../../search-utils/searchConstants';
import { StateType } from '../../../../state/reducers';
import styles from './search_filters_sort.module.scss';

type Props = {
  sortType: StateType['queryParams']['sort'];
  track: Function;
  searchType: 'arret' | 'commentary';
};

export const SearchFiltersSort: FC<Props> = ({ sortType, track }) => {
  function onClick(toggle: Function, value: boolean) {
    return () => {
      track('all_filters', value);
      toggle();
    };
  }

  return (
    <div className={styles.container}>
      <span className={styles.label}>
        <FormattedMessage id="search/components/search-filters-bar/SearchFiltersSort/1" />
      </span>
      <CustomDropdown>
        {(isOpen, toggle) => (
          <FilterDropdown>
            <FilterDropdownButton isSelected onClick={onClick(toggle, !isOpen)}>
              <FormattedMessage id={searchConstants.sorts[sortType].labelId} />
            </FilterDropdownButton>
            {isOpen && (
              <FilterDropdownBox className={styles.box}>
                <div className={styles.dropdown}>
                  <SortList onClick={toggle} />
                </div>
              </FilterDropdownBox>
            )}
          </FilterDropdown>
        )}
      </CustomDropdown>
    </div>
  );
};
